import { RealEstateCategory } from "server/coreApi/terminals/constants.js";

export { RealEstateCategory };

export const VALID_BUILDING_CATEGORIES = [
  RealEstateCategory.Office,
  RealEstateCategory.ShoppingCenter,
  RealEstateCategory.IndustrialPark,
];
